import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  FETCH_EMPRESAS,
  FETCH_EMPRESAS_SUCCESS,
  FETCH_EMPRESAS_ERROR,
  SET_EMPRESA_SELECCIONADA,
} from "./actionTypes"

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  }
}

export const loginSuccess = data => {
  return {
    type: LOGIN_SUCCESS,
    payload: data,
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const fetchEmpresas = () => {
  return {
    type: FETCH_EMPRESAS,
  }
}

export const fetchEmpresasSuccess = empresas => {
  return {
    type: FETCH_EMPRESAS_SUCCESS,
    payload: empresas,
  }
}

export const fetchEmpresasError = error => {
  return {
    type: FETCH_EMPRESAS_ERROR,
    payload: error,
  }
}

export const setEmpresaSeleccionada = (empresa, history) => {
  return {
    type: SET_EMPRESA_SELECCIONADA,
    payload: { empresa, history },
  }
}